import type { SaleOrderDetails } from '@am3nd-org/pointcraft-types';

// ----------------------------------------------------------------------
// Staff meals (Restaurant POS design v4) are kitchen-only orders: they reach
// ordersHub, the KDS and the kitchen printer with no sale, no payment and no
// inventory change. On the register draft the choice rides in an
// `orderDetails.staffMeal` extension (SaleOrderDetails accepts JSON extensions,
// so no shared-type change is needed); on the kitchen root it becomes
// `fulfillmentType: 'STAFF_MEAL'` with `paymentState: 'NO_CHARGE'` and the
// employee's name in `customerName`.
// ----------------------------------------------------------------------

export interface StaffMealDetails {
  employeeId: string | null;
  name: string;
  role: string | null;
}

/** The staff member chosen on a draft, or `null` when the order is not a staff meal. */
export function staffMealFromOrderDetails(
  details: SaleOrderDetails | null | undefined
): StaffMealDetails | null {
  const value = (details as Record<string, unknown> | null | undefined)?.staffMeal;
  if (!value || typeof value !== 'object') return null;
  const record = value as Record<string, unknown>;
  return {
    employeeId: typeof record.employeeId === 'string' ? record.employeeId : null,
    name: typeof record.name === 'string' ? record.name : '',
    role: typeof record.role === 'string' ? record.role : null,
  };
}

/** A staff meal is ready to send once someone is picked. */
export function hasStaffMember(staff: StaffMealDetails | null): staff is StaffMealDetails {
  return Boolean(staff?.name.trim());
}
